
  var aui = window['aui'] = window['aui'] || {};
  // This file was automatically generated from template12.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace aui.page.
 */

if (typeof aui == 'undefined') { var aui = {}; }
if (typeof aui.page == 'undefined') { aui.page = {}; }


aui.page.page = function(opt_data, opt_ignored) {
  return '<div id="page"><header id="header" role="banner" aria-label="' + soy.$$escapeHtml(AJS.I18n.getText('aui.landmarks.site')) + '">' + soy.$$filterNoAutoescape(opt_data.headerContent) + '</header><div id="content">' + soy.$$filterNoAutoescape(opt_data.contentContent) + '</div><footer id="footer" role="contentinfo">' + soy.$$filterNoAutoescape(opt_data.footerContent) + '</footer></div>';
};
if (goog.DEBUG) {
  aui.page.page.soyTemplateName = 'aui.page.page';
}


aui.page.genericElement = function(opt_data, opt_ignored) {
  var output = '';
  var theTag__soy16 = opt_data.tagName ? opt_data.tagName : 'div';
  var theId__soy17 = opt_data.id && opt_data.id != false && opt_data.id != 'false' ? opt_data.id : false;
  output += '<' + soy.$$escapeHtml(theTag__soy16) + aui.page.roleAttribute({tagName: theTag__soy16}) + ((theId__soy17) ? ' id="' + soy.$$escapeHtml(theId__soy17) + '"' : '') + ' class="' + soy.$$escapeHtml(opt_data.className) + aui.renderExtraClasses(opt_data) + '" ' + aui.renderExtraAttributes(opt_data) + '>' + soy.$$filterNoAutoescape(opt_data.content) + '</' + soy.$$escapeHtml(theTag__soy16) + '>';
  return output;
};
if (goog.DEBUG) {
  aui.page.genericElement.soyTemplateName = 'aui.page.genericElement';
}


aui.page.roleAttribute = function(opt_data, opt_ignored) {
  var output = '';
  var role__soy39 = '';
  switch (opt_data.tagName) {
    case 'main':
      role__soy39 += 'main';
      break;
    case 'header':
      role__soy39 += 'banner';
      break;
    case 'footer':
      role__soy39 += 'contentinfo';
      break;
    case 'aside':
      role__soy39 += 'complementary';
      break;
    case 'nav':
      role__soy39 += 'navigation';
      break;
  }
  output += (role__soy39) ? ' role="' + soy.$$escapeHtml(role__soy39) + '"' : '';
  return output;
};
if (goog.DEBUG) {
  aui.page.roleAttribute.soyTemplateName = 'aui.page.roleAttribute';
}


aui.page.document = function(opt_data, opt_ignored) {
  return '<!DOCTYPE html><html lang="en">' + aui.page.documentHTMLContent(opt_data) + '</html>';
};
if (goog.DEBUG) {
  aui.page.document.soyTemplateName = 'aui.page.document';
}


aui.page.documentHTMLContent = function(opt_data, opt_ignored) {
  var output = '';
  var thePageSize__soy61 = opt_data.pageSize ? opt_data.pageSize : opt_data.focusedPageSize ? opt_data.focusedPageSize : 'xlarge';
  output += '<head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width"><title>' + soy.$$escapeHtml(opt_data.windowTitle) + '</title>' + ((opt_data.headContent) ? soy.$$filterNoAutoescape(opt_data.headContent) : '') + '</head><body' + ((opt_data.pageType) ? (opt_data.pageType == 'generic') ? (opt_data.extraClasses) ? ' class="' + aui.renderExtraClasses(opt_data) + '"' : '' : (opt_data.pageType == 'focused') ? ' class="aui-page-focused aui-page-focused-' + soy.$$escapeHtml(thePageSize__soy61) + ' aui-page-size-' + soy.$$escapeHtml(thePageSize__soy61) + aui.renderExtraClasses(opt_data) + '"' : (opt_data.pageType == 'notification') ? ' class="aui-page-notification aui-page-size-' + soy.$$escapeHtml(thePageSize__soy61) + aui.renderExtraClasses(opt_data) + '"' : (opt_data.pageType == 'sidebar') ? ' class="aui-page-sidebar' + soy.$$escapeHtml(opt_data.sidebarState ? ' aui-sidebar-' + opt_data.sidebarState : '') + aui.renderExtraClasses(opt_data) + '"' : ' class="aui-page-' + soy.$$escapeHtml(opt_data.pageType) + aui.renderExtraClasses(opt_data) + '"' : ' class="' + aui.renderExtraClasses(opt_data) + '"') + aui.renderExtraAttributes(opt_data) + '>' + soy.$$filterNoAutoescape(opt_data.content) + '</body>';
  return output;
};
if (goog.DEBUG) {
  aui.page.documentHTMLContent.soyTemplateName = 'aui.page.documentHTMLContent';
}


aui.page.header = function(opt_data, opt_ignored) {
  var output = '';
  if (opt_data.skipLinks) {
    var linkList113 = opt_data.skipLinks;
    var linkListLen113 = linkList113.length;
    for (var linkIndex113 = 0; linkIndex113 < linkListLen113; linkIndex113++) {
      var linkData113 = linkList113[linkIndex113];
      output += '<a class="aui-skip-link" href="' + soy.$$escapeHtml(linkData113.href) + '">' + soy.$$escapeHtml(linkData113.label) + '</a>';
    }
  }
  output += '<nav' + ((opt_data.id) ? ' id="' + soy.$$escapeHtml(opt_data.id) + '"' : '') + ' class="aui-header aui-dropdown2-trigger-group' + aui.renderExtraClasses(opt_data) + '"' + aui.renderExtraAttributes(opt_data) + ' aria-label="' + soy.$$escapeHtml(AJS.I18n.getText('aui.landmarks.site')) + '"><div class="aui-header-inner">' + ((opt_data.headerBeforeContent) ? '<div class="aui-header-before">' + soy.$$filterNoAutoescape(opt_data.headerBeforeContent) + '</div>' : '') + '<div class="aui-header-primary"><span id="logo" class="aui-header-logo' + ((opt_data.headerLogoImageUrl) ? ' aui-header-logo-custom' : (opt_data.logo) ? ' aui-header-logo-' + soy.$$escapeHtml(opt_data.logo) : '') + '"><a href="' + soy.$$escapeHtml(opt_data.headerLink ? opt_data.headerLink : '/') + '" aria-label="' + ((opt_data.headerAriaLabel) ? soy.$$filterNoAutoescape(opt_data.headerAriaLabel) : soy.$$escapeHtml(AJS.I18n.getText('aui.header.home.link'))) + '">' + ((opt_data.headerLogoImageUrl) ? '<img src="' + soy.$$escapeHtml(opt_data.headerLogoImageUrl) + '" alt="' + soy.$$escapeHtml(opt_data.headerLogoText) + '" />' : '<span class="aui-header-logo-device">' + soy.$$escapeHtml(opt_data.headerLogoText ? opt_data.headerLogoText : '') + '</span>') + ((opt_data.headerText) ? '<span class="aui-header-logo-text">' + soy.$$escapeHtml(opt_data.headerText) + '</span>' : '') + '</a></span>' + ((opt_data.primaryNavContent) ? soy.$$filterNoAutoescape(opt_data.primaryNavContent) : '') + '</div>' + ((opt_data.secondaryNavContent) ? '<div class="aui-header-secondary">' + soy.$$filterNoAutoescape(opt_data.secondaryNavContent) + '</div>' : '') + ((opt_data.headerAfterContent) ? '<div class="aui-header-after">' + soy.$$filterNoAutoescape(opt_data.headerAfterContent) + '</div>' : '') + '</div><!-- .aui-header-inner--><aui-header-end></aui-header-end></nav><!-- .aui-header -->';
  return output;
};
if (goog.DEBUG) {
  aui.page.header.soyTemplateName = 'aui.page.header';
}


aui.page.pageHeader = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {className: 'aui-page-header', patternName: '.aui-page-header', content: '<div class="aui-page-header-inner">' + soy.$$filterNoAutoescape(opt_data.content) + '</div>'}));
};
if (goog.DEBUG) {
  aui.page.pageHeader.soyTemplateName = 'aui.page.pageHeader';
}


aui.page.pageHeaderImage = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {className: 'aui-page-header-image', patternName: '.aui-page-header-image'}));
};
if (goog.DEBUG) {
  aui.page.pageHeaderImage.soyTemplateName = 'aui.page.pageHeaderImage';
}


aui.page.pageHeaderMain = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {className: 'aui-page-header-main', patternName: '.aui-page-header-main'}));
};
if (goog.DEBUG) {
  aui.page.pageHeaderMain.soyTemplateName = 'aui.page.pageHeaderMain';
}


aui.page.pageHeaderActions = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {className: 'aui-page-header-actions', patternName: '.aui-page-header-actions'}));
};
if (goog.DEBUG) {
  aui.page.pageHeaderActions.soyTemplateName = 'aui.page.pageHeaderActions';
}


aui.page.pagePanel = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {className: 'aui-page-panel', patternName: '.aui-page-panel', content: '<div class="aui-page-panel-inner">' + soy.$$filterNoAutoescape(opt_data.content) + '</div>'}));
};
if (goog.DEBUG) {
  aui.page.pagePanel.soyTemplateName = 'aui.page.pagePanel';
}


aui.page.pagePanelNav = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {className: 'aui-page-panel-nav', patternName: '.aui-page-panel-nav'}));
};
if (goog.DEBUG) {
  aui.page.pagePanelNav.soyTemplateName = 'aui.page.pagePanelNav';
}


aui.page.pagePanelContent = function(opt_data, opt_ignored) {
  var output = '';
  var theId__soy226 = opt_data.id == false || opt_data.id == 'false' ? false : opt_data.id ? opt_data.id : 'main';
  output += aui.page.genericElement(soy.$$augmentMap(opt_data, {id: theId__soy226, tagName: opt_data.tagName ? opt_data.tagName : 'main', className: 'aui-page-panel-content', patternName: '.aui-page-panel-content'}));
  return output;
};
if (goog.DEBUG) {
  aui.page.pagePanelContent.soyTemplateName = 'aui.page.pagePanelContent';
}


aui.page.pagePanelSidebar = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {tagName: opt_data.tagName ? opt_data.tagName : 'aside', className: 'aui-page-panel-sidebar', patternName: '.aui-page-panel-sidebar'}));
};
if (goog.DEBUG) {
  aui.page.pagePanelSidebar.soyTemplateName = 'aui.page.pagePanelSidebar';
}


aui.page.pagePanelItem = function(opt_data, opt_ignored) {
  return '' + aui.page.genericElement(soy.$$augmentMap(opt_data, {tagName: opt_data.tagName ? opt_data.tagName : 'section', className: 'aui-page-panel-item', patternName: '.aui-page-panel-item'}));
};
if (goog.DEBUG) {
  aui.page.pagePanelItem.soyTemplateName = 'aui.page.pagePanelItem';
}

        module.exports = aui.page;